import { dayKeySchema } from './day-key.model';
import { utcInstantSchema } from './utc-instant.model';

export const readEnvelopeShape = {
  serverNow: utcInstantSchema,
  tenantToday: dayKeySchema,
} as const;

export interface ReadEnvelope {
  serverNow: string;
  tenantToday: string;
}

export function pageCoversItems(page: { total: number; items: readonly unknown[] }): string | null {
  return page.total >= page.items.length ? null : 'a total covering every returned item';
}
